import React from 'react'
import { BiSolidDownArrow, BiSolidUpArrow } from 'react-icons/bi'

import { OrderDetailsType } from '../../../../api/services/orders/types.ts'
import Button from '../../../common/Button/Button.tsx'

const HeaderSection = ({
  order,
  setShowSurvey,
  showSurvey
}: {
  order: OrderDetailsType | null
  setShowSurvey: React.Dispatch<React.SetStateAction<boolean>>
  showSurvey: boolean
}) => {
  return (
    <div
      className={
        'flex-1 flex flex-col items-center pb-4 dark:border-gray-700 gap-y-4'
      }
    >
      <p className={'text-black dark:text-white text-[22px] pt-4'}>Ankieta</p>

      <div
        className={
          'flex-1 flex flex-col md:flex-row items-center justify-center md:gap-x-8 gap-y-4'
        }
      >
        <div className={'flex flex-row items-center'}>
          <p
            className={
              'font-bold inline-flex rounded-xl py-3 px-6 bg-green-800 text-lime-400'
            }
          >
            {order && order.patient_profile.patient_type}
          </p>
        </div>

        <div className={'flex flex-col items-center'}>
          <Button
            variant="filled"
            size="medium"
            color="primary"
            type="button"
            onClick={() => setShowSurvey(!showSurvey)}
            icon={showSurvey ? <BiSolidUpArrow /> : <BiSolidDownArrow />}
            // className="bg-blue-400 text-white rounded-md shadow-md hover:bg-green-600 transition-colors"
          >
            {showSurvey ? 'Zwiń' : 'Rozwiń'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default HeaderSection
